import { Cookies } from 'react-cookie';
import { COOKIES } from '../../constants/misc.js';

function saveAuthToken(token) {
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const cookies = new Cookies();
    cookies.set(COOKIES.token, token, {
        secure: ENV === "production",
        sameSite: "strict",
        path: "/",
        maxAge: 24 * 60 * 60 * 30
    });
    return;
}

export { saveAuthToken };
//# sourceMappingURL=saveAuthToken.js.map
